// extracted by mini-css-extract-plugin
export var active = "_e9-7";
export var blink = "_e9-8";
export var dropDownSelector = "_e9-4";
export var dropDownWrapper = "_e9-3";
export var fakeCursor = "_e9-6";
export var fontSizeButton = "_e9-9";
export var formQuillEditor = "_e9-0";
export var pressed = "_e9-a";
export var qlBlank = "_e9-1";
export var textFormattingToolbar = "_e9-2";
export var textToolbarOption = "_e9-5";